import styles from "../../../../styles/patient-page-modules/Charts.module.css";

import { formatDate, formatNumber, convertUTCToLocal } from "../../../../utils/helper";

export const weightColumns = [
  {
    key: "reading_dates",
    // SCRUM-968: header click sorts by the timestamp this column shows
    // (no reading has a reading_dates field).
    sortField: "recorded_at",
    label: "Reading Dates",
    alignLeft: true,
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "weight",
    label: "Weight",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.weight < 120
                ? "green"
                : reading.weight < 130
                ? "yellow"
                : "red",
            borderColor:
              reading.weight < 120
                ? "greenyellow"
                : reading.weight < 130
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {formatNumber("decimal", reading.weight)} lbs
      </div>
    ),
  },
  //   {
  //     key: "diastolic",
  //     label: "Diastolic",
  //     render: (reading) => (
  //       <div className={styles.condition}>
  //         <div
  //           className={styles.condition_mark}
  //           style={{
  //             backgroundColor:
  //               reading.value2 < 80
  //                 ? "green"
  //                 : reading.value2 < 90
  //                 ? "yellow"
  //                 : "red",
  //             borderColor:
  //               reading.value2 < 80
  //                 ? "greenyellow"
  //                 : reading.value2 < 90
  //                 ? "gold"
  //                 : "orange",
  //           }}
  //         ></div>{" "}
  //         {reading.value2} mm Hg
  //       </div>
  //     ),
  //   },

  // {
  //   key: "pulse",
  //   label: "Pulse",
  //   render: (reading) => (
  //     <div className={styles.condition}>
  //       <div
  //         className={styles.condition_mark}
  //         style={{
  //           backgroundColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "green"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "red"
  //               : "yellow",
  //           borderColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "greenyellow"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "orange"
  //               : "gold",
  //         }}
  //       ></div>{" "}
  //       {reading.pulse} bpm
  //     </div>
  //   ),
  // },
];
